(function () {
  const upsell = document.querySelector(".ck-upsell");
  if (!upsell) return;

  const list = upsell.querySelector(".ck-upsell__list");
  const items = Array.from(upsell.querySelectorAll(".ck-upsell__item"));
  const dots = Array.from(upsell.querySelectorAll(".ck-upsell__dot"));

  if (!list || items.length === 0 || dots.length === 0) return;

  /* ----------------------------------------
   * dots logic (scroll progress based)
   * ---------------------------------------- */

  function updateActiveDot() {
    const maxScroll = list.scrollWidth - list.clientWidth;

    if (maxScroll <= 0) {
      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === 0));
      return;
    }

    const progress = list.scrollLeft / maxScroll;
    const index = Math.round(progress * (dots.length - 1));

    dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
  }

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      const maxScroll = list.scrollWidth - list.clientWidth;

      const target = (index / (dots.length - 1)) * maxScroll;

      list.scrollTo({
        left: target,
        behavior: "smooth",
      });
    });
  });

  /* ----------------------------------------
   * desktop drag = native free scroll
   * ---------------------------------------- */

  let isDown = false;
  let startX = 0;
  let startScrollLeft = 0;

  function isInteractiveTarget(el) {
    return !!el.closest(
      "a, button, input, select, textarea, label, [role='button'], [data-no-drag]"
    );
  }

  list.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    if (isInteractiveTarget(e.target)) return;

    isDown = true;
    list.classList.add("is-dragging");

    startX = e.pageX;
    startScrollLeft = list.scrollLeft;
  });

  window.addEventListener("mousemove", (e) => {
    if (!isDown) return;

    const dx = e.pageX - startX;
    list.scrollLeft = startScrollLeft - dx;
  });

  window.addEventListener("mouseup", () => {
    if (!isDown) return;

    isDown = false;
    list.classList.remove("is-dragging");
  });

  list.addEventListener("mouseleave", () => {
    if (!isDown) return;

    isDown = false;
    list.classList.remove("is-dragging");
  });

  /* ----------------------------------------
   * sync dots
   * ---------------------------------------- */

  list.addEventListener("scroll", () => {
    requestAnimationFrame(updateActiveDot);
  });

  window.addEventListener("resize", updateActiveDot);

  updateActiveDot();
})();
